export default __webpack_public_path__ + "static/media/travel-booking.3f5de1df.avif";